/* Product form: variant pill selection, price and availability updates,
   and the quantity stepper. Variant data is rendered as JSON by Liquid. */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var atcButtons = document.querySelectorAll('[data-variant-id][data-product-form-id="' + root.id + '"]');
    var optionInputs = root.querySelectorAll('[data-option-input]');

    function money(cents) {
      var format = root.getAttribute('data-money-format') || '${{amount}}';
      var value = (cents / 100).toFixed(2);
      return format.replace(/\{\{\s*amount\s*\}\}/, value);
    }

    function selectedOptions() {
      var chosen = [];
      root.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) chosen.push(checked.value);
      });
      return chosen;
    }

    function findVariant() {
      var chosen = selectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return opt === chosen[i]; });
      }) || null;
    }

    function update() {
      var variant = findVariant();
      atcButtons.forEach(function (button) {
        if (!variant || !variant.available) {
          button.disabled = true;
          button.textContent = variant ? button.getAttribute('data-sold-out-text') : button.getAttribute('data-unavailable-text');
        } else {
          button.disabled = false;
          button.textContent = button.getAttribute('data-atc-text');
          button.setAttribute('data-variant-id', variant.id);
          button.setAttribute('data-price', (variant.price / 100).toFixed(2));
        }
      });
      if (priceEl && variant) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (variant && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', update); });

    root.querySelectorAll('[data-quantity-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = root.querySelector('[data-product-quantity]');
        if (!input) return;
        var delta = parseInt(button.getAttribute('data-quantity-change'), 10);
        var next = (parseInt(input.value, 10) || 1) + delta;
        input.value = Math.max(1, next);
      });
    });

    update();
  });
})();
